import { useEffect } from "react";

/** Calls `onEscape` when Escape is pressed while `enabled`. */
export function useEscapeKey(
  enabled: boolean,
  onEscape: () => void,
): void {
  useEffect(() => {
    if (!enabled) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== "Escape") return;
      e.preventDefault();
      onEscape();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [enabled, onEscape]);
}
